// src/pages/NewsPage.jsx
import { useEffect, useState } from "react";
import axios from "axios";
import { Edit, Trash2, PlusCircle } from "lucide-react";

export default function NewsPage() {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  // For edit modal
  const [editData, setEditData] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const fetchNews = async () => {
    try {
      const res = await axios.get("https://gp-chandoli-khurd.com/backend/api/news/get_news.php");
      setNews(res.data);
    } catch (err) {
      console.error("Error fetching news:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNews();
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this news?")) return;

    try {
      await axios.delete(`https://gp-chandoli-khurd.com/backend/api/news/delete_news.php?id=${id}`);
      setNews(news.filter((item) => item.id !== id));
    } catch (err) {
      console.error("Error deleting:", err);
    }
  };

  const handleEdit = (item) => {
    setEditData(item);
    setShowModal(true);
  };

  const handleUpdate = async () => {
    try {
      const formData = new FormData();
      formData.append("id", editData.id);
      formData.append("title", editData.title);
      formData.append("content", editData.content);

      if (editData.photoFile) {
        formData.append("photo", editData.photoFile);
      }
      if (editData.pdfFile) {
        formData.append("pdf_file", editData.pdfFile);
      }

      await axios.post("https://gp-chandoli-khurd.com/backend/api/news/update_news.php", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      setNews(news.map((n) => (n.id === editData.id ? editData : n)));
      setShowModal(false);
    } catch (err) {
      console.error("Error updating:", err);
    }
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-semibold text-gray-800">News</h2>
        <button
          onClick={() => alert("Open add modal")}
          className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
        >
          <PlusCircle size={18} /> Entry
        </button>
      </div>

      {/* Loading */}
      {loading ? (
        <p className="text-gray-500">Loading...</p>
      ) : news.length === 0 ? (
        <p className="text-gray-500">No news found.</p>
      ) : (
        /* Table */
        <div className="overflow-x-auto bg-white rounded-md border border-gray-200">
          <table className="w-full border-collapse text-sm">
            <thead>
              <tr className="bg-gray-100 text-gray-700 text-left">
                <th className="p-3 border">ID</th>
                <th className="p-3 border">Title</th>
                <th className="p-3 border">Content</th>
                <th className="p-3 border">Photo</th>
                <th className="p-3 border">PDF</th>
                <th className="p-3 border">Created At</th>
                <th className="p-3 border">Updated At</th>
                <th className="p-3 border text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              {news.map((item, index) => (
                <tr
                  key={item.id}
                  className={`${index % 2 === 0 ? "bg-white" : "bg-gray-50"} hover:bg-gray-100 transition`}
                >
                  <td className="p-3 border">{item.id}</td>
                  <td className="p-3 border font-medium text-gray-900">{item.title}</td>
                  <td className="p-3 border text-gray-700">{item.content}</td>
                  {/* <td className="p-3 border text-gray-500">
                    {item.photo ? (
                      <a href={item.photo} target="_blank" rel="noreferrer" className="text-blue-600 hover:underline">
                        View
                      </a>
                    ) : "N/A"}
                  </td> */}

                  <td className="p-3 border text-gray-500">
                    {item.photo ? (
                      <a
                        href={`https://gp-chandoli-khurd.com/backend/${item.photo}`}
                        target="_blank"
                        rel="noreferrer"
                        className="text-blue-600 hover:underline"
                      >
                        View Photo
                      </a>
                    ) : (
                      "N/A"
                    )}
                  </td>

                  {/* <td className="p-3 border text-gray-500">
                    {item.pdf_file ? (
                      <a href={item.pdf_file} target="_blank" rel="noreferrer" className="text-blue-600 hover:underline">
                        PDF
                      </a>
                    ) : "N/A"}
                  </td> */}

                  <td className="p-3 border text-gray-500">
                    {item.pdf_file ? (
                      <a
                        // href={`http://grampanchayat.local/uploads/${item.pdf_file}`}
                        href={`https://gp-chandoli-khurd.com/backend//${item.pdf_file}`}
                        target="_blank"
                        rel="noreferrer"
                        className="text-blue-600 hover:underline"
                      >
                        View PDF
                      </a>
                    ) : (
                      "N/A"
                    )}
                  </td>

                  <td className="p-3 border text-gray-600">{item.created_at}</td>
                  <td className="p-3 border text-gray-600">{item.updated_at}</td>
                  <td className="p-3 border flex items-center justify-center gap-3">
                    <button className="text-blue-600 hover:text-blue-800" onClick={() => handleEdit(item)}>
                      <Edit size={18} />
                    </button>
                    <button className="text-red-600 hover:text-red-800" onClick={() => handleDelete(item.id)}>
                      <Trash2 size={18} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Modal */}
      {showModal && editData && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
          <div className="bg-white p-6 rounded shadow-md w-96">
            <h2 className="text-lg font-semibold mb-4">Edit News</h2>
            <input
              type="text"
              value={editData.title}
              onChange={(e) => setEditData({ ...editData, title: e.target.value })}
              className="w-full border p-2 mb-3"
              placeholder="Title"
            />
            <textarea
              value={editData.content}
              onChange={(e) => setEditData({ ...editData, content: e.target.value })}
              className="w-full border p-2 mb-3"
              placeholder="Content"
            />

            {/* Photo Upload */}
            <label className="block mb-2 text-sm text-gray-600">Photo</label>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => setEditData({ ...editData, photoFile: e.target.files[0] })}
              className="w-full border p-2 mb-3"
            />

            {/* PDF Upload */}
            <label className="block mb-2 text-sm text-gray-600">PDF</label>
            <input
              type="file"
              accept="application/pdf"
              onChange={(e) => setEditData({ ...editData, pdfFile: e.target.files[0] })}
              className="w-full border p-2 mb-3"
            />

            <div className="flex justify-end gap-3 mt-4">
              <button onClick={() => setShowModal(false)} className="px-3 py-1 bg-gray-400 text-white rounded">
                Cancel
              </button>
              <button onClick={handleUpdate} className="px-3 py-1 bg-blue-600 text-white rounded">
                Update
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
  